import moment from 'moment'
import _ from 'lodash'

const ViewBreakPoints = [
  // hour
  {
    index: 0,
    rangeSelectorFormat: 'hh:mm A',
    primaryFormat: {label: 'ha', label_sub: null},
    secondaryFormat: {label: 'MMM DD ', label_sub: 'YYYY'},
    eventDisplayFormat: {label: 'ddd ', label_sub: 'Do'},
    minWidth: 48,
    maxWidth: 136,
    percentMin: 66,
    percentMax: 100,
    getMoment: startMilliSec => moment(startMilliSec).set({minute: 0, second: 0, millisecond: 0}),
    getNextMoment: (startMilliSec, step = 1) => moment(startMilliSec).add({hour: 1 * step}),
    getPrevMoment: (startMilliSec, step = 1) => moment(startMilliSec).subtract({hour: 1 * step}),
    zoomInBreakPointIndex: 0, // primary click
    zoomOutBreakPointIndex: 1, // secondary click
  },
  // day
  {
    index: 1,
    rangeSelectorFormat: 'hh A',
    primaryFormat: {label: 'DD', label_sub: 'ddd'},
    secondaryFormat: {label: 'MMM', label_sub: 'YYYY'},
    eventDisplayFormat: {label: 'MMM ', label_sub: 'Do'},
    minWidth: 48,
    maxWidth: 160,
    percentMin: 33,
    percentMax: 65,
    getMoment: startMilliSec =>
      moment(startMilliSec).set({hour: 0, minute: 0, second: 0, millisecond: 0}),
    getNextMoment: (startMilliSec, step = 1) => moment(startMilliSec).add({day: 1 * step}),
    getPrevMoment: (startMilliSec, step = 1) => moment(startMilliSec).subtract({day: 1 * step}),
    zoomInBreakPointIndex: 0, // primary click
    zoomOutBreakPointIndex: 2, // secondary click
  },
  // month
  {
    index: 2,
    rangeSelectorFormat: 'DD MMM',
    primaryFormat: {label: 'MMM', label_sub: null},
    secondaryFormat: {label: 'YYYY', label_sub: null},
    eventDisplayFormat: {label: 'MMM ', label_sub: null},
    minWidth: 96,
    maxWidth: 184,
    percentMin: 1,
    percentMax: 32,
    getMoment: startMilliSec =>
      moment(startMilliSec)
        .set({minute: 0, hour: 0, second: 0, millisecond: 0})
        .startOf('month'),
    getNextMoment: (startMilliSec, step = 1) => moment(startMilliSec).add({month: 1 * step}),
    getPrevMoment: (startMilliSec, step = 1) => moment(startMilliSec).subtract({month: 1 * step}),
    zoomInBreakPointIndex: 1, // primary click
    zoomOutBreakPointIndex: 2, // secondary click
  },
]

const OverrideViewBreakpoints = (override = {}) => {
  const indexes = ['hour', 'day', 'month']
  return _.map(ViewBreakPoints, (v, i) => ({...v, ...(override[indexes[i]] || {})}))
}

export default ViewBreakPoints
export {OverrideViewBreakpoints}
